import { render } from "./ClassLink.vue?vue&type=template&id=6443e4a2"
import script from "./ClassLink.vue?vue&type=script&lang=js"
export * from "./ClassLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__